module.exports = __webpack_public_path__ + "assets/img/confirm.3238d338.png";